export const adminStorageKey = "Parse/userAdmin";
export const vitaeAuthTokenKey = "vitaeAuthToken";
export const vitaeIndividualTokenKey = "vitaeIndividualToken";
export const vitaeOrganizationTokenKey = "vitaeOrganizationToken";
